import { apiClient } from "@/shared/services/api";
import type { ApiResponse } from "@/features/auth/services/authApi";

export interface CollectionReleaseLine {
  id: string;
  orderItemId: string;
  productName: string;
  variety?: string;
  releasedQuantity: number;
  collectedQuantity: number;
  availableQuantity: number;
  preparedQuantity: number;
  stockIssue?: string;
}

export interface CollectionRelease {
  id: string;
  orderId: string;
  orderNumber: string;
  customerName: string;
  paymentStatus: string;
  collectionStatus: string;
  collectionPreparedAt?: string;
  dispatchRecordId?: string;
  handoverStatus?: string;
  rowVersion: number;
  items: CollectionReleaseLine[];
}

export interface CollectionReleasePage {
  items: CollectionRelease[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

export interface ConfirmCollectionRequest {
  collectorName: string;
  isCustomerPersonally: boolean;
  collectorPhone?: string;
  collectorReference?: string;
  notes?: string;
  rowVersion: number;
  items: Array<{ fulfilmentReleaseItemId: string; collectedQuantity: number }>;
}

export const collectionsApi = {
  getReady: async (search: string, pageNumber: number, pageSize = 25) => {
    const params = new URLSearchParams({ pageNumber: String(pageNumber), pageSize: String(pageSize) });
    if (search) params.set("search", search);
    const response = await apiClient.get<ApiResponse<CollectionReleasePage>>(`/collections/ready?${params}`);
    return response.data.data!;
  },
  prepare: async (release: CollectionRelease, notes?: string) => {
    const response = await apiClient.post<ApiResponse<CollectionRelease>>(`/collections/${release.id}/prepare`, {
      notes, rowVersion: release.rowVersion,
    });
    return response.data.data!;
  },
  cancel: async (release: CollectionRelease, reason: string) => {
    const response = await apiClient.post<ApiResponse<CollectionRelease>>(`/collections/${release.id}/cancel`, {
      reason, rowVersion: release.rowVersion,
    });
    return response.data.data!;
  },
  confirm: async (releaseId: string, request: ConfirmCollectionRequest, idempotencyKey: string) => {
    const response = await apiClient.post<ApiResponse<unknown>>(`/collections/${releaseId}/confirm`, request, {
      headers: { "Idempotency-Key": idempotencyKey },
    });
    return response.data.data;
  },
};
